<template>
  <div class="col-sm-12">
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools" />
        <div style="padding-right: 10px;">
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="name" label="通路名稱" />
            <el-table-column prop="storeId" :formatter="getStoreText" label="隸屬商店" />
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
      <el-dialog
        center
        class="col-12"
        :title="getTitle()"
        :visible.sync="modals.custom">
        <div class='main'>
          <div class='col-sm-12'>
            <fg-input label="通路名稱"
                    type="text"
                    name="name"
                    class='row'
                    labelClasses="col-md-2 col-12 my-auto"
                    inputClasses="col-md-9 col-12"
                    data-vv-as="通路名稱"
                    v-model="form.name"
                    v-validate="'required'"    
                    :error="getError('name')"
                    required />
            <div class="form-group align-left row">
              <label class='col-md-2 col-12 my-auto'>隸屬商店 *</label>
              <div class='col-md-9 col-12 row main'>
                <el-select class="select-default" data-vv-as="隸屬商店" placeholder="請選擇" name="storeId" v-model="form.storeId" :error="getError('storeId')"  v-validate="'required'" >
                    <el-option v-for="i in stores" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
                </el-select>
              </div>
              <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('storeId')">{{ errors.first('storeId') }}</div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
        </div>
      </el-dialog>
    </card>
  </div>
</template>


<script>
 /* eslint-disable */
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../../lib'
  import tools from '../../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          name: '',
          storeId: ''
        },
        searchForm: {
        },
        query: {
        },
        stores:[],
        modals: {
          custom: false
        },
        tableData: []
      }
    },
    async mounted() {
      await this.getStores()
      await this.getData()
    },
    methods: {
      getStoreText(row, idx) {
        var storeId = row.storeId
        for (var i=0 ; i < this.stores.length ; i++) {
          if (this.stores[i]['id'] == storeId) {
            return this.stores[i]['name']
          }
        }
        return ''
      },
      getTitle() {
        return (this.form.id == '')?'新增通路':'編輯通路'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return
          _this.createAndUpdate()
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name,
        this.form.storeId = row.storeId,
        this.openModal('custom')
      },
      doSearch() {
        // this.getData()
      },
      async getStores() {
        var data = await lib.getStoreList({ offset:0, limit:10 })
        if (data.status == 0) {
          var result = data.result
          this.stores = result.stores
        }
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getBranchList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.branches
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
            _this.form.id = ''
            _this.form.name = ''
            _this.form.storeId = ''
          resolve()
        })
      },
      async createAndUpdate() {
        var actionText = ''
        if (this.form.id === '') {
          var data = await lib.createBranch(this.form)
          actionText = '新增'
        } else {
          var data = await lib.updateBranch(this.form.id, this.form);
          actionText = '更新'
        }
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal(`已${actionText}`, '', 'success')
        } else {
          this.$swal(`${actionText}失敗`, '', 'error')
        }
      },
      async handleDelete(id, prop) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>

.main {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}

.rightBtn {
  display: flex;
  justify-content: space-between;
}

</style>
